import classNames from 'classnames'
import React from 'react'

import s from './StatusItem.module.scss'
import type { StatusItemProps } from './StatusItem.props'

export function StatusItem({ title, style, onClick }: StatusItemProps) {
  return (
    <div
      className={classNames(s.item, { [s.clickable]: !!onClick })}
      style={style}
      onClick={onClick}
      title={title}
    >
      {title}
    </div>
  )
}
